import type { ModalData } from '..';

export interface BuyerChecklistModalItem {
  id: string;
  title: string;
  content: string;
}

export interface BuyerChecklistModalData {
  modal: ModalData;
  items: BuyerChecklistModalItem[];
}

export interface BuyerChecklistModalProps extends BuyerChecklistModalData {}
